// sub_type コードと日本語ラベルのマッピング
// DB 명세 기준:
//   1: 事前アンケート (アンケート系サーベイ用)
//   2: 直後アンケート
//   3: 事後アンケート
//   4: 本人用       (360度診断系サーベイ用)
//   5: 協力者用
//
// アンケート系 (例: 20110) は 1/2/3
// 360度診断系 (例: 40010) は 4/5

export const SUB_TYPE_LABEL = {
  1: '事前アンケート',
  2: '直後アンケート',
  3: '事後アンケート',
  4: '本人用',
  5: '協力者用',
};

// サーベイコードに応じて、有効な sub_type 配列を返す
// 詳細モーダルでタブ構成に使用する
export const getSubTypesForSurvey = (surveyCode) => {
  const code = String(surveyCode || '');
  // 360度診断系
  if (code === '40010' || code === '60020') {
    return ['4', '5'];
  }
  // アンケート系
  if (code === '20110' || code === '20210') {
    return ['1', '2', '3'];
  }
  // それ以外は空 (sub_type 概念なし)
  return [];
};

export const getSubTypeLabel = (subType) =>
  SUB_TYPE_LABEL[subType] ?? String(subType ?? '-');
